import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export const AMENITY_LOCATIONS_QUERY_KEY = 'getAmenityLocations'

export const getReservationDetailsQueryKey = (amenityId?: number) => [
  AMENITY_LOCATIONS_QUERY_KEY,
  amenityId,
]

type Location = {
  amenityId: number
  available: boolean
  createdAt: number
  description: string
  id: number
  image: string
  name: string
  reservations: number
  updatedAt: number
}

type AmenityLocationsResponse = {
  locations: Location[]
}

const getAmenityLocations = async ({ amenityId, ...params }: GetAmenityLocationsRequest) => {
  const response = await authAPI.get<AmenityLocationsResponse>(`/amenity/${amenityId}/location`, {
    params,
  })
  return response.data.locations
}

export type GetAmenityLocationsRequest = {
  amenityId?: number
  search?: string
  date?: number
  endDate?: number
  timestamp?: number
  startTime?: number
  endTime?: number
}

export const useGetAmenityLocations = ({ amenityId, ...params }: GetAmenityLocationsRequest) =>
  useQuery({
    enabled: !!amenityId,
    queryFn: () => getAmenityLocations({ amenityId, ...params }),
    queryKey: getReservationDetailsQueryKey(amenityId),
  })
